<template>
    <div class="container">
        <div :class="{
            'row card': true,
            'rounded m-3': publicCheckout
        }">
            <div v-if="publicCheckout">
                <base-logo class="main-logo w-300"></base-logo>
            </div>
            <base-table-spinner v-if="isLoading"></base-table-spinner>

            <div v-else class="col-sm-10">
                <h2>{{ heading }}</h2>
                <p>{{ description }}</p>
                <hr />
                <InvoicePreview :invoice="invoice" />
                <br />
                <div class="text-center">
                    <router-link to="/">
                        <b-button variant="primary" class="mt-3">
                            Back Home
                        </b-button>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import request from '@/utils/request'
import InvoicePreview from '../../components/InvoicePreview.vue';

export default {
    components: {
        InvoicePreview,
    },
    data(){
        return {
            heading: 'Processing...',
            description: '',
            invoice: null,
            isLoading: false,
            publicCheckout: true,

        }
    },
    async mounted(){
        const urlParams = new URLSearchParams(window.location.search);
        const setupIntentSecret = urlParams.get('setup_intent');
        const paymentIntentSecret = urlParams.get('payment_intent');
        const redirectStatus = urlParams.get('redirect_status');

        if(redirectStatus=='succeeded' && (setupIntentSecret || paymentIntentSecret)) {
            const type = setupIntentSecret ? 'setup-intent' : 'payment-intent';
            const invoice = await this.getInvoiceIdFromSetupSecret( setupIntentSecret || paymentIntentSecret, type);
            if(invoice) {
                const today = new Date()
                const paymentDate = new Date(invoice.date)
                if(paymentDate > today) {
                    this.heading = 'Thank You!';
                    this.description = 'Your payment details have been securely processed. Your subscription payment will be deducted as per invoice.';
                } else  {
                    this.heading = 'Thanks for purchasing!';
                    this.description = 'Payment receipt has been sent to your registered email.';
                }
            }
        }
    },

    methods: {
        async getInvoiceIdFromSetupSecret(secret, type){
            try{
                this.isLoading = true
                const formData = {
                    data: this.$encryptData({
                        secret,
                        type
                    })
                }
                const {data} = await request.post('/users/invoice-from-secret', formData)
                this.invoice = data.invoice;
                this.logout()
                return data.invoice;
                
            }catch(e) {
                console.log('error invoice', e)
            } finally {
                this.isLoading = false
            }
        },
        logout(){
            this.$store.commit('setUser', null)
            this.$store.commit('setToken', null)
            this.$store.commit('setTokenExpiry', null)
        },
    }
    
}
</script>

<style scoped>

.main-logo {
    display: flex;
    justify-content: center;
}
</style>
